import i18n from "../i18n";

const SUPPORTED = ["en", "de", "zh"];
const STORAGE_KEY = "df_language";

export const normalizeLanguageCode = (input) => {
  const raw = String(input || "").trim().toLowerCase().replace("_", "-");
  if (!raw) return "en";
  if (raw.startsWith("de")) return "de";
  if (raw.startsWith("zh")) return "zh";
  if (raw.startsWith("en")) return "en";
  return SUPPORTED.includes(raw) ? raw : "en";
};

export const getSelectedLanguage = () => {
  try {
    const stored =
      typeof window !== "undefined" && window.localStorage
        ? window.localStorage.getItem(STORAGE_KEY)
        : null;
    if (stored) return normalizeLanguageCode(stored);
  } catch {}
  return normalizeLanguageCode(i18n.resolvedLanguage || i18n.language || "en");
};

